"use strict";
var Observable_1 = require('../../Observable');
var ignoreElements_1 = require('../../operator/ignoreElements');
Observable_1.Observable.prototype.ignoreElements = ignoreElements_1.ignoreElements;
//# sourceMappingURL=ignoreElements.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/ignoreElements.js
// module id = 985
// module chunks = 3